<template>
    <div class="submain">
        <h1>我的收藏夹</h1>
        <div class="content">
            <div class="flexbox top">
                <div class="left">
                    <el-checkbox v-model="allcol">全选</el-checkbox>
                    <el-button type="danger">删除</el-button>
                </div>
                <div class="right">您共收藏了<span class="redw">{{ collectionNum }}</span>个商品</div>
            </div>
            <div class="con">
                <div class="flexbox item" v-for="(item, index) in 10" :key="index">
                    <div class="flexbox left">
                        <el-checkbox v-model="allcol"></el-checkbox>
                        <div class="flexbox goodsmsg">
                            <img src="../../../assets/img/goods.png">
                            <div class="msg">
                                <p class="name">迈克球铁沟槽短型刚性卡箍（1GX）DN32-DN250</p>
                                <span class="redw">¥ 199</span>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <el-button plain>查看详情</el-button>
                        <el-button plain>删除</el-button>
                    </div>
                </div>
            </div>
            <div class="pages">
                <el-pagination @current-change="handleCurrentChange" 
                v-model:currentPage="currentPage" :page-size="100" :total="1000" 
                layout="prev, pager, next, jumper" background></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref } from 'vue'

    export default {
        name: 'FinancialOverview',
        setup() {
            let collections = ref([])
            let collectionNum = ref('0')
            let allcol = ref(false)
            let selAll = () => {
                
            }
            return {
                collections,
                collectionNum,
                allcol,
                selAll
            }
        }
    }
</script>

<style scoped lang="scss">
    .submain {
        padding: 10px;
        background: #fff;
        h1 {
            font-size: 16px;
            padding: 10px 0;
            border-bottom: 1px solid rgba(223, 223, 223, 1);
        }
        .content {
            padding-bottom: 20px;
            .top {
                padding: 20px 10px;
                border-bottom: 1px solid rgba(242, 242, 242, 1);
                justify-content: space-between;
                .left {
                    ::v-deep(.el-button--danger) {
                        height: 30px;
                        margin-left: 20px;
                    }
                }
                .right {
                    font-size: 12px;
                    .redw {
                        font-size: 12px;
                    }
                }
            }
            .con {
                margin-bottom: 25px;
                .item {
                    justify-content: space-between;
                    padding: 20px 10px;
                    border-bottom: 1px solid rgba(242, 242, 242, 1);
                    .left {
                        .goodsmsg {
                            img {
                                width: 80px;
                                height: 80px;
                                margin: 0 15px;
                            }
                            .msg {
                                .name {
                                    font-size: 12px;
                                    margin-bottom: 10px;
                                }
                                .redw {}
                            }
                        }
                    }
                    .right {
                        ::v-deep(.el-button) {
                            height: 30px;
                            width: 87px;
                            display: block;
                            margin: 10px 0;
                            font-size: 12px;
                        }
                    }
                }
            }
            .pages {}
        }
    }
</style>